/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from './'
import $const from '../common/constant'

export default {

  //获取企业树
  getTree: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getTree', params)
  },

  //获取企业树(模糊查询)
  findTree: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/findTree', params)
  },
  //获取企业树(模糊查询)
  findRepeatedTree: params => {
    return API.GET($const.apiServer.Admin+'/enterprisebase/findRepeatedTree', params)
  },

  //根据当前企业id获取企业树（从顶级节点开始）
  getTreeById: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getTreeById', params)
  },
  //查询全部企业
  pageList: params => {
    return API.GET($const.apiServer.Admin+'/enterprisebase/pageList', params)
  },
  //获得企业列表
  findList: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/list', params)
  },

  queryList: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/queryList', params)
  },
  
  queryListByIndustry: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/queryListByIndustry', params)
  },

  //根据id获得企业信息
  findById: id => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/findById/' + id)
  },

  //保存企业信息
  save: params => {
    return API.POST($const.apiServer.Admin + '/enterprisebase/save', params)
  },

  //修改企业信息
  update: (id, params) => {
    return API.PUT($const.apiServer.Admin + '/enterprisebase/update', params)
  },

  //根据id删除企业信息
  remove: id => {
    return API.DELETE($const.apiServer.Admin + '/enterprisebase/remove?id=' + id)
  },

  //批量删除
  batchRemove: (ids) => {
    return API.DELETE($const.apiServer.Admin + '/enterprisebase/batchRemove/' + ids)
  },

  //获得企业类型
  getEnterType: () => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getEnterType')
  },

  //获得企业性质
  getEnterNature: () => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getEnterNature')
  },
  //充值
  getEnterAccount: (params) => {
    return API.POST($const.apiServer.Admin + '/enterprisebase/account', params)
  },
  //线上充值
  getEnterAccountOnline: (params) => {
    return API.GET('/mall/scan/scanPay', params)
  },
  //获得所属区域
  getArea: params => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getArea', params)
  },

  //根据编码获得下级区域
  getAreaByCode: areaCode => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getAreaByCode?areaCode=' + areaCode)
  },

  //根据所属公司id获得职务
  getPost: enterpriseId => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getPost?enterpriseId=' + enterpriseId)
  },

  //获得行业
  getIndustry: (parentId, level) => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getIndustry?parentId=' + parentId + '&level=' + level)
  },
  getIndustryTree: (parentCode) => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getIndustryTree?parentCode=' + parentCode)
  },

  //根据企业id获得所属行业/专业/小专业
  findIndustrysListByEntId: id => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/findIndustrysListByEntId?id=' + id)
  },
  //根据id获得企业信息
  findEntById: id => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/findById?id=' + id)
  },
  //根据联系人手机获取公司信息
  getCompanyInfoByFhone: (params) => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/getCompanyInfoByFhone', params)
  },
  // 激活
  activate: (params) => {
    return API.POST($const.apiServer.Admin + '/enterprisebase/activate', params)
  },
  //发送验证码
  sendActivateSms: (params) => {
    return API.GET($const.apiServer.Admin + '/enterprisebase/sendActivateSms', params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_enterprisebase.js